import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Vip from "./pages/Vip";
import Withdraw from "./pages/Withdraw";
import Referrals from "./pages/Referrals";
import Transactions from "./pages/Transactions";
import Earnings from "./pages/Earnings";
import Team from "./pages/Team";
import Support from "./pages/Support";
import SettingsPage from "./pages/SettingsPage";
import Admin from "./pages/Admin";
import RequestPoints from "./pages/RequestPoints";

// ============================================================
// PROTECTED ROUTE
// ============================================================

function ProtectedRoute({ children, adminOnly = false }) {
  const token = localStorage.getItem("token");

  const storedUser = localStorage.getItem("user");

  let user = null;

  try {
    user = storedUser
      ? JSON.parse(storedUser)
      : null;
  } catch (error) {
    console.error("USER PARSE ERROR:", error);
    user = null;
  }

  // Not logged in
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Admin-only page
  if (adminOnly && !user?.is_admin) {
    return <Navigate to="/" replace />;
  }

  // Normal user page
  if (!adminOnly && user?.is_admin) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}

// ============================================================
// PUBLIC ROUTE
// ============================================================

function PublicRoute({ children }) {
  const token = localStorage.getItem("token");

  const storedUser = localStorage.getItem("user");

  let user = null;

  try {
    user = storedUser
      ? JSON.parse(storedUser)
      : null;
  } catch (error) {
    console.error("USER PARSE ERROR:", error);
    user = null;
  }

  if (!token) {
    return children;
  }

  return (
    <Navigate
      to={user?.is_admin ? "/admin" : "/"}
      replace
    />
  );
}

// ============================================================
// APP
// ============================================================

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* ================================================== */}
        {/* LOGIN */}
        {/* ================================================== */}

        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* ================================================== */}
        {/* DASHBOARD */}
        {/* ================================================== */}

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* VIP LEVELS */}
        {/* ================================================== */}

        <Route
          path="/vip"
          element={
            <ProtectedRoute>
              <Vip />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* DEPOSIT (now uses the real, verified request flow) */}
        {/* ================================================== */}

        <Route
          path="/deposit"
          element={
            <ProtectedRoute>
              <RequestPoints />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* PAYMENT METHOD */}
        {/* ================================================== */}

        <Route
          path="/request-points"
          element={
            <ProtectedRoute>
              <RequestPoints />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* WITHDRAW */}
        {/* ================================================== */}

        <Route
          path="/withdraw"
          element={
            <ProtectedRoute>
              <Withdraw />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* REFERRALS */}
        {/* ================================================== */}

        <Route
          path="/referrals"
          element={
            <ProtectedRoute>
              <Referrals />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* TRANSACTIONS */}
        {/* ================================================== */}

        <Route
          path="/transactions"
          element={
            <ProtectedRoute>
              <Transactions />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* EARNINGS */}
        {/* ================================================== */}

        <Route
          path="/earnings"
          element={
            <ProtectedRoute>
              <Earnings />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* TEAM */}
        {/* ================================================== */}

        <Route
          path="/team"
          element={
            <ProtectedRoute>
              <Team />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* SUPPORT */}
        {/* ================================================== */}

        <Route
          path="/support"
          element={
            <ProtectedRoute>
              <Support />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* SETTINGS */}
        {/* ================================================== */}

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* ADMIN */}
        {/* ================================================== */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute adminOnly>
              <Admin />
            </ProtectedRoute>
          }
        />

        {/* ================================================== */}
        {/* UNKNOWN ROUTE */}
        {/* ================================================== */}

        <Route
          path="*"
          element={
            <Navigate to="/" replace />
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;